export default "__VITE_ASSET__DNQ1$oME__"